import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f7ee989"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"footer_top\" data-v-1f7ee989><div class=\"footer_hotline\" data-v-1f7ee989><div class=\"hotline_text\" data-v-1f7ee989><span class=\"hotline_label\" data-v-1f7ee989>全国统一服务热线</span><span class=\"hotline_time\" data-v-1f7ee989>服务时间：8:00-21:00</span></div><div class=\"sep-line-v\" data-v-1f7ee989></div><a class=\"hotline_num\" href=\"tel:400-900-6896\" data-v-1f7ee989>400-900-6896</a></div></div>", 1)
const _hoisted_3 = { class: "footer_bottom" }
const _hoisted_4 = { class: "footer_about" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"footer_meta\" data-v-1f7ee989><p data-v-1f7ee989>版权所有：北京中盛佳源教育科技有限公司</p><span class=\"meta-divider\" data-v-1f7ee989></span><p class=\"footer_link\" data-v-1f7ee989><a href=\"http://beian.miit.gov.cn\" data-v-1f7ee989>京ICP备15052609号-2</a></p><span class=\"meta-divider\" data-v-1f7ee989></span><p class=\"footer_power\" data-v-1f7ee989><img src=\"https://img.alicdn.com/tfs/TB13DzOjXP7gK0jSZFjXXc5aXXa-212-48.png\" data-v-1f7ee989> 提供计算与安全服务 </p></div>", 1)

import {reactive} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const data: any = reactive({
	aboutItem: [
		{
			'name': '加入我们',
			'link': '/666',
		},
		{
			'name': '关于我们',
			'link': '/777',
		},
		{
			'name': '联系我们',
			'link': '/888',
		},
	],
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.aboutItem, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: item,
            to: item.link
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ]),
      _hoisted_5
    ])
  ]))
}
}

})